import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { EPage } from '@types';

import { PAGES } from '../constants';

export interface IUseRedirectMethod {
  (page: EPage, urlParam?: string): void;
}
export const useRedirect = (): IUseRedirectMethod => {
  const {
    applicationSettings: { features },
  } = useApplicationRuntimeContext();

  const {
    settings: { websiteHostAddress },
  } = useApplicationBuildContext();

  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (page: EPage, urlParam?: string) => {
      const pageRoutes = PAGES[page];

      if (!pageRoutes) {
        return;
      }

      const { internal, external } = pageRoutes;

      if (features.pages.has(EPage[page]) && internal) {
        navigate(`${internal}${urlParam ?? ''}`, { state: { from: `${location.pathname}${location.search ?? ''}` } });
        return;
      }

      if (websiteHostAddress) {
        window.location.href = `${websiteHostAddress}${external}${urlParam ?? ''}`;
      }
    },
    [websiteHostAddress, navigate, features, location.search, location.pathname],
  );
};
